import * as THREE from "three";
import { LEAN_TYPE_NUM_TO_STR } from "../../../Constants/constant";
import { converImageIntoBase64, upperCaseFirst } from "../../../redux/reducers/building_pricing/pricingReducer";
import {  const_var, params } from "../../../redux/reducers/reducer";
import { calcOverhangSize } from "../../building_component/buildingComponent.helper";
import { setDefaultLeanToData } from "../../lean_building_pricing/leanBuilding.helper";
import { applyColorToParams, setDefaultBuildingColorById } from "../building_color/building.color.helper";
import { getSidingOrientationOptions, setDefaultBuildingMaterialById } from "../building_material/buildingMaterial.helper";
import * as utlis from "../../../redux/reducers/utils";
export const loadDefaultBuilding = (state, data, buildingID) => {
	state.defaultBuilding = const_var.selectedDefaultIndex;
	let filterRecord = "";
	if (data) {
		for (let i = 0; i < data.length; i++) {
			if (const_var.stateManufacturerAcordingAPI[params.p_s_n]?.building_type !== undefined && const_var.stateManufacturerAcordingAPI[params.p_s_n].building_type.length > 0) {
				filterRecord = const_var.stateManufacturerAcordingAPI[params.p_s_n].building_type.filter((newData) => newData == data[i].id);

				if (filterRecord.length > 0 && filterRecord[0] == data[i].id) {
					if (data[i].heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
						const_var.defaultBuildingArr[data[i].id] = data[i];
						if (state.defaultBuilding == undefined) {
							params.p_b_t = data[0].building_id;
						}
					}
					if (const_var.CheckSnowLoadValue != 65) {
						const_var.defaultBuildingArr[data[i].id] = data[i];
						if (state.defaultBuilding == undefined) {
							params.p_b_t = data[0].building_id;
						}
					}
				} else {
					if (data[i].heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
						const_var.defaultBuildingArr[data[i].id] = data[i];
						if (state.defaultBuilding == undefined) {
							params.p_b_t = data[0].building_id;
						}
					}
					if (const_var.CheckSnowLoadValue != 65) {
						const_var.defaultBuildingArr[data[i].id] = data[i];
						if (state.defaultBuilding == undefined) {
							params.p_b_t = data[0].building_id;
						}
					}
				}
			} else {
				if (data[i].heavy_snow == 1 && const_var.CheckSnowLoadValue == 65) {
					const_var.defaultBuildingArr[data[i].id] = data[i];
					if (state.defaultBuilding == undefined) {
						params.p_b_t = data[0].building_id;
					}
				}
				if (const_var.CheckSnowLoadValue != 65) {
					const_var.defaultBuildingArr[data[i].id] = data[i];
					if (state.defaultBuilding == undefined) {
						params.p_b_t = data[0].building_id;
					}
				}
			}
		}
	}
	if (const_var.defaultBuildingArr[state.defaultBuilding] == undefined) {
		return true;
	}
	const selectedDefaultBuilding = const_var.defaultBuildingArr[state.defaultBuilding];
	setDefaultLeanToData(const_var, state, params, upperCaseFirst);
	const_var.defalutProductLoad = true;
	const_var.defaultBuildingImgName = selectedDefaultBuilding?.image_name?.split(".")[0] || selectedDefaultBuilding.name;
	params.p_b_t = selectedDefaultBuilding.building_id != undefined ? selectedDefaultBuilding.building_id : params.p_b_t;
	params.building_type_name = selectedDefaultBuilding.name != undefined ? selectedDefaultBuilding.name : "Carport";
	params.p_r_s = selectedDefaultBuilding.roof_id != undefined ? selectedDefaultBuilding.roof_id : params.p_r_s;
	params.p_w = selectedDefaultBuilding.size != undefined ? parseInt(selectedDefaultBuilding.size.split("x")[0]) : params.p_w;
	params.p_d = selectedDefaultBuilding.size != undefined ? parseInt(selectedDefaultBuilding.size.split("x")[1]) : params.p_d;
	params.p_h = selectedDefaultBuilding.size != undefined ? parseInt(selectedDefaultBuilding.size.split("x")[2]) : params.p_h;
	params.other_building_type_name = `${params.building_type_name} - ${params.p_w} x ${params.p_d} x ${params.p_h}`;
	params.p_v_w = selectedDefaultBuilding?.is_vertical ? true : false;
	setDefaultBuildingColorById(const_var.color, selectedDefaultBuilding);
	setDefaultBuildingMaterialById(const_var.mainSidingOptions, selectedDefaultBuilding);
	if (const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch != undefined && const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch != null) {
		state.params.b_r_p = const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch?.replace("/", "");
		state.params.p_r_p = const_var.defaultBuildingArr[state.defaultBuilding].central_roof_pitch.split("/")[0];
	}
	params.p_u_c = const_var.defaultBuildingArr[state.defaultBuilding].utility != undefined && const_var.defaultBuildingArr[state.defaultBuilding].utility != 0 ? true : false;
	params.p_u_t =
		const_var.defaultBuildingArr[state.defaultBuilding].utility != undefined && const_var.defaultBuildingArr[state.defaultBuilding].utility != 0
			? parseInt(const_var.defaultBuildingArr[state.defaultBuilding].utility)
			: 5;
	params.endStoragePositionZ = const_var.defaultBuildingArr[state.defaultBuilding].utility_position != undefined ? const_var.defaultBuildingArr[state.defaultBuilding].utility_position : 0;
	params.p_i_s = params.p_i_s;
	params.cB_addStorage_check_left =
		const_var.defaultBuildingArr[state.defaultBuilding].left_utility != undefined &&
		const_var.defaultBuildingArr[state.defaultBuilding].side_combo_length != 0 &&
		const_var.defaultBuildingArr[state.defaultBuilding].left_utility == true
			? true
			: false;
	params.cB_addStorage_check_right =
		const_var.defaultBuildingArr[state.defaultBuilding].right_utility != undefined &&
		const_var.defaultBuildingArr[state.defaultBuilding].side_combo_length != 0 &&
		const_var.defaultBuildingArr[state.defaultBuilding].right_utility == true
			? true
			: false;

	params.cB_addStorage_left = params.cB_addStorage_check_left ? const_var.defaultBuildingArr[state.defaultBuilding].side_combo_length : 0;
	params.cB_addStorage_right = params.cB_addStorage_check_right ? const_var.defaultBuildingArr[state.defaultBuilding].side_combo_length : 0;
	if (params.p_u_c == true || params.cB_addStorage_check_left || params.cB_addStorage_check_right) {
		params.nostorage = false;
	}

	params.cB_addStorage_check_front = const_var.defaultBuildingArr[state.defaultBuilding].utility_front && const_var.defaultBuildingArr[state.defaultBuilding].utility != 0 ? true : false;
	params.cB_addStorage_front =
		const_var.defaultBuildingArr[state.defaultBuilding].utility_front && const_var.defaultBuildingArr[state.defaultBuilding].utility != 0
			? Number(const_var.defaultBuildingArr[state.defaultBuilding].utility_front)
			: 5;

	params.b_l_l_t_l = params.p_b_c_b_l;
	params.b_l_l_t_f = params.p_b_c_b_l_f;
	params.b_l_l_t_b = params.p_b_c_b_l_b;
	params.b_l_l_t_r = params.p_b_c_b_l_r;

	params.b_r_l_t_r = params.p_b_c_b_r;
	params.b_r_l_t_f = params.p_b_c_b_r_f;
	params.b_r_l_t_b = params.p_b_c_b_r_b;
	params.b_r_l_t_l = params.p_b_c_b_r_r;

	params.p_b_c_b_f_f = params.p_b_c_b_f_f;
	params.p_b_c_b_f_b = params.p_b_c_b_f_b;
	params.p_b_c_b_f_l = params.p_b_c_b_f_l;

	params.p_b_c_b_b_f = params.p_b_c_b_b_f;
	params.p_b_c_b_b_b = params.p_b_c_b_b_b;
	params.p_b_c_b_b_l = params.p_b_c_b_b_l;
	params.p_l_b_l =
		(const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].leanto_type == 1) || (const_var.newLeanArr["gable_left"] != undefined && const_var.newLeanArr["gable_left"].leanto_type == 1)
			? false
			: true;
	params.p_r_b_l =
		(const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].leanto_type == 2) || (const_var.newLeanArr["gable_right"] != undefined && const_var.newLeanArr["gable_right"].leanto_type == 2)
			? false
			: true;
	const wallObj = const_var?.defaultBuildingArr?.[state?.defaultBuilding]?.wall;

	if (wallObj && Object.keys(wallObj).length > 1 && wallObj.front !== undefined) {
		params.p_f_w = const_var.defaultBuildingArr[state.defaultBuilding].wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall.front) : params.p_f_w;
		params.p_b_w = const_var.defaultBuildingArr[state.defaultBuilding].wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall.back) : params.p_b_w;
		params.p_l_w = const_var.defaultBuildingArr[state.defaultBuilding].wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall.left) : params.p_l_w;
		params.p_r_w = const_var.defaultBuildingArr[state.defaultBuilding].wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall.right) : params.p_r_w;
		params.p_f_w_f = params.p_f_w;
	} else {
		params.p_f_w = const_var.defaultBuildingArr[state.defaultBuilding]?.wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall) : params.p_f_w;
		params.p_b_w = const_var.defaultBuildingArr[state.defaultBuilding]?.wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall) : params.p_b_w;
		params.p_l_w = const_var.defaultBuildingArr[state.defaultBuilding]?.wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall) : params.p_l_w;
		params.p_r_w = const_var.defaultBuildingArr[state.defaultBuilding]?.wall != null ? upperCaseFirst(const_var.defaultBuildingArr[state.defaultBuilding].wall) : params.p_r_w;
		params.p_f_w_f = params.p_f_w;
	}
	params.prev_p_b_w = params.p_b_w;
	params.p_c_a_w = params.p_b_w == "Close" && params.p_l_w == "Close" && params.p_r_w == "Close" && params.p_f_w == "Close" ? true : false;
	params.p_c_a_l_l_w = params.p_b_c_b_l_f == "Close" && params.p_b_c_b_l_b == "Close" && params.p_b_c_b_l == "Close" ? true : false;
	params.p_c_a_r_l_w = params.p_b_c_b_r_f == "Close" && params.p_b_c_b_r_b == "Close" && params.p_b_c_b_r == "Close" ? true : false;
	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].leanto_type == 1) {
		params.continous_left_lean = const_var.newLeanArr["left"].continous_lean == true ? true : false;
		params.add_left_lean = true;
		params.lean_p_w = parseInt(const_var.newLeanArr["left"].width);
		params.lean_p_d = parseInt(const_var.newLeanArr["left"].length);
		params.lean_p_h = parseInt(const_var.newLeanArr["left"].height);
		params.add_storage_check = const_var.newLeanArr["left"].has_utility == true ? true : false;
		params.add_storage = const_var.newLeanArr["left"].utility_length ? const_var.newLeanArr["left"].utility_length : 5;
		const_var.lengthData.leftLean.length = Number(params.lean_p_d);
		if (params.add_storage_check == true) {
		}
		if (params.continous_left_lean == true) {
		}
	} else if (const_var.newLeanArr["gable_left"] != undefined && const_var.newLeanArr["gable_left"].leanto_type == 1) {
		params.continous_left_lean = const_var.newLeanArr["gable_left"].continous_lean == true ? true : false;
		params.add_left_lean = true;
		params.leanStyle.left = "gable";
		params.leantoAlignmentLeft = const_var.defaultBuildingArr[state.defaultBuilding].name.includes("L") ? "2" : params.leantoAlignmentLeft;
		params.lean_p_w = parseInt(const_var.newLeanArr["gable_left"].width);
		params.lean_p_d = parseInt(const_var.newLeanArr["gable_left"].length);
		params.lean_p_h = parseInt(const_var.newLeanArr["gable_left"].height);
		params.add_storage_check = const_var.newLeanArr["gable_left"].has_utility == true ? true : false;
		params.add_storage = const_var.newLeanArr["gable_left"].utility_length ? const_var.newLeanArr["gable_left"].utility_length : 5;
		const_var.lengthData.leftLean.length = Number(params.lean_p_d);
		if (params.add_storage_check == true) {
		}
		if (params.continous_left_lean == true) {
		}
	} else {
		params.continous_left_lean = false;
		params.add_left_lean = false;
		params.lean_p_w = 12;
		params.lean_p_d = 21;
		params.lean_p_h = 6;
		params.add_storage_check = false;
	}
	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].leanto_type == 2) {
		params.continous_right_lean = const_var.newLeanArr["right"].continous_lean == true ? true : false;
		params.add_right_lean = true;
		params.leanR_p_w = parseInt(const_var.newLeanArr["right"].width);
		params.leanR_p_d = parseInt(const_var.newLeanArr["right"].length);
		params.leanR_p_h = parseInt(const_var.newLeanArr["right"].height);
		params.add_storage_check_right = const_var.newLeanArr["right"].has_utility == true ? true : false;
		params.add_storage_right = const_var.newLeanArr["right"].utility_length ? const_var.newLeanArr["right"].utility_length : 5;
		const_var.lengthData.rightLean.length = Number(params.leanR_p_d);
		if (params.add_storage_check_right == true) {
		}
		if (params.continous_right_lean == true) {
		}
		//$(".RightBranLean input:checkbox").prop('checked',true);
	} else if (const_var.newLeanArr["gable_right"] != undefined && const_var.newLeanArr["gable_right"].leanto_type == 2) {
		params.continous_right_lean = const_var.newLeanArr["gable_right"].continous_lean == true ? true : false;
		params.add_right_lean = true;
		params.leanStyle.right = "gable";
		params.leanR_p_w = parseInt(const_var.newLeanArr["gable_right"].width);
		params.leanR_p_d = parseInt(const_var.newLeanArr["gable_right"].length);
		params.leanR_p_h = parseInt(const_var.newLeanArr["gable_right"].height);
		params.add_storage_check_right = const_var.newLeanArr["gable_right"].has_utility == true ? true : false;
		params.add_storage_right = const_var.newLeanArr["gable_right"].utility_length ? const_var.newLeanArr["gable_right"].utility_length : 5;
		const_var.lengthData.rightLean.length = Number(params.leanR_p_d);
		if (params.add_storage_check_right == true) {
		}
		if (params.continous_right_lean == true) {
		}
	} else {
		params.continous_right_lean = false;
		params.add_right_lean = false;
		params.leanR_p_w = 12;
		params.leanR_p_d = 21;
		params.leanR_p_h = 6;
		params.add_storage_check_right = false;
	}
	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].leanto_type == 3) {
		params.add_front_lean = true;
		params.leanF_p_w = parseInt(const_var.newLeanArr["front"].width);
		params.leanF_p_d = parseInt(const_var.newLeanArr["front"].length);
		params.leanF_p_h = parseInt(const_var.newLeanArr["front"].height);

		const_var.lengthData.frontLean.length = Number(params.leanF_p_d);
	} else if (const_var.newLeanArr["gable_front"] != undefined && const_var.newLeanArr["gable_front"].leanto_type == 3) {
		params.add_front_lean = true;
		params.leanStyle.front = "gable";
		params.leanF_p_w = parseInt(const_var.newLeanArr["gable_front"].width);
		params.leanF_p_d = parseInt(const_var.newLeanArr["gable_front"].length);
		params.leanF_p_h = parseInt(const_var.newLeanArr["gable_front"].height);
		params.add_storage_check_front = const_var.newLeanArr["gable_front"].has_utility == true ? true : false;
		params.add_storage_front = const_var.newLeanArr["gable_front"].utility_length ? const_var.newLeanArr["gable_front"].utility_length : 5;
		const_var.lengthData.frontLean.length = Number(params.leanR_p_d);
		if (params.add_storage_check_right == true) {
		}
		if (params.continous_right_lean == true) {
		}
	} else {
		params.add_front_lean = false;
		params.leanF_p_w = 12;
		params.leanF_p_d = 21;
		params.leanF_p_h = 6;
	}

	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].leanto_type == 4) {
		params.add_back_lean = true;
		params.leanB_p_w = parseInt(const_var.newLeanArr["back"].width);
		params.leanB_p_d = parseInt(const_var.newLeanArr["back"].length);
		params.leanB_p_h = parseInt(const_var.newLeanArr["back"].height);
		const_var.lengthData.frontLean.length = Number(params.leanF_p_d);
	} else if (const_var.newLeanArr["gable_back"] != undefined && const_var.newLeanArr["gable_back"].leanto_type == 4) {
		params.add_back_lean = true;
		params.leanStyle.back = "gable";
		params.leanB_p_w = parseInt(const_var.newLeanArr["gable_back"].width);
		params.leanB_p_d = parseInt(const_var.newLeanArr["gable_back"].length);
		params.leanB_p_h = parseInt(const_var.newLeanArr["gable_back"].height);
		params.add_storage_check_back = const_var.newLeanArr["gable_back"].has_utility == true ? true : false;
		params.add_storage_back = const_var.newLeanArr["gable_back"].utility_length ? const_var.newLeanArr["gable_back"].utility_length : 5;
		const_var.lengthData.backLean.length = Number(params.leanR_p_d);
	} else {
		params.add_back_lean = false;
		params.leanB_p_w = 12;
		params.leanB_p_d = 21;
		params.leanB_p_h = 6;
	}

	params.add_storage_check_1 = params.add_storage_check;
	params.add_storage_check_right_1 = params.add_storage_check_right;

	utlis.prepareLoftDropdown();
	if (const_var.crmSetting.main_domain_url == "idealsteelbuildingsofca.com" && const_var.loginSession == false) {
		utlis.onWidthHeightChange(params.p_w, params.p_h);
	}
};
export const EditloadDefaultBuilding = (state, data, sourceData, building_images, personlInfo, statesRec, allData) => {
	let previousWallTexture = "";
	let previousSelSidingOption = "";
	const_var.onDragUtilityPriceUpdateLeft = true;
	const_var.onDragUtilityPriceUpdateRight = true;
	const_var.onDragUtilityPriceUpdateFront = true;
	const_var.onDragUtilityPriceUpdateBack = true;
	const_var.onDragUtilityPriceUpdateCenterBuilding = true;
	if (const_var.isFromPickThis) {
		previousWallTexture = params.wallTexture;
		previousSelSidingOption = const_var.selSidingOption;
	}

	if (data.building && data.building.heavy_snow != 1 && data.building.building_type) {
		let filterData = allData?.building_data?.default_building?.find((obj) => obj.building_id == data.building.building_type);
		if (filterData && filterData.heavy_snow && filterData.heavy_snow == 1) {
			const_var.CheckSnowLoadValue = 65;
			params.isSnowLoad = true;
			data.building.heavy_snow = 1;
		}
	}

	let editData = data.building;
	if (const_var.isFromCompare) {
		const_var.is_edit_labour = undefined;
	} else {
		const_var.is_edit_labour = true;
	}
	let installationValueArray = { Concrete: 1, Asphalt: 2, Ground: 3, Gravel: 4 };

	const_var.defaultProData = editData;
	params.p_w = editData.width;
	params.p_d = editData.length;
	params.p_h = editData.height;
	params.isShowCenter = false;
	params.isBuildingStyleChange = true;
	if (editData.display_building_type_name != "") {
		if (editData.display_building_type_name.includes("Carport")) {
			const_var.eventKey = "carports";
		} else if (editData.display_building_type_name.includes("Garage")) {
			const_var.eventKey = "garages";
		} else if (editData.display_building_type_name.includes("Commercial")) {
			const_var.eventKey = "commercial";
		} else if (editData.display_building_type_name.includes("Barn")) {
			const_var.eventKey = "barns";
		} else if (editData.display_building_type_name.includes("RV")) {
			const_var.eventKey = "rvcover";
		} else if (editData.display_building_type_name.includes("Standing")) {
			const_var.eventKey = "freestanding";
		} else if (editData.display_building_type_name.includes("Custom Buildings")) {
			const_var.eventKey = "customizations";
		} else if (editData?.default_building_image_name?.includes("shape") || editData?.default_building_image_name?.includes("Front_to_Back")) {
			const_var.eventKey = "LTshape";
		}
	}

	if (state?.const_var?.crmSetting?.is_zipcode_screen && state?.const_var?.crmSetting?.is_Edit && editData && (editData.state_mfg_zipcode == null || editData.state_mfg_zipcode == "")) {
		const_var.showStateBoxInZipErr = false;
	}
	// ################### Assigning Insulation of lean to's ###################
	if (const_var.insulationJsonLeanTo.length == 0 && editData.leanto.length > 0) {
		for (let i = 0; i < editData.leanto[0].pricing_data.insulation.length; i++) {
			const_var.insulationJsonLeanTo[editData.leanto[0].pricing_data.insulation[i].insulation_id] = editData.leanto[0].pricing_data.insulation[i].name;
		}
	}
	if (const_var?.UpdatedPriceData?.down_payment_discount_rate && const_var?.isKLinkEnable != true) {
		const_var.UpdatedPriceData.down_payment_discount_rate_Updated = const_var.UpdatedPriceData.down_payment_discount_rate;
	}

	params.p_w_c_n = editData.wainscot && editData.wainscot_type != undefined ? true : false;
	params.p_b_t = editData.building_type;
	if (params.p_b_t == 27) {
		const_var.navEventKey.leanto = "rightLean";
	}

	const_var.selSidingObj = editData?.siding_obj;
	params.wallTexture = utlis.sidingNameUpdateForWallTexture(const_var.selSidingObj.name);
	if (editData) {
		if (allData.pricing_data && !const_var.isFromCompare) {
			const_var.holdPricingResponse = JSON.parse(JSON.stringify(allData.pricing_data));
		}
		const hasAtLeastOneGable = editData.leanto?.find((l) => l.leanto_style === "gable");
		if (hasAtLeastOneGable) {
			const_var.isLTBuilding = true;
		}

		editData.leanto?.forEach((lean) => {
			if (lean.leanto_style === "gable") {
				if (lean.leanto_type == 1) {
					const_var.wallNameArray["p_b_c_b_l_r"] = "right";
					const_var.wallNameArray["p_b_c_b_l"] = "left";
				}
				if (lean.leanto_type == 2) {
					const_var.wallNameArray["p_b_c_b_r_r"] = "left";
					const_var.wallNameArray["p_b_c_b_r"] = "right";
				}
				if (lean.leanto_type == 3) {
					const_var.wallNameArray["p_b_c_b_f_r"] = "right";
					const_var.wallNameArray["p_b_c_b_f_l"] = "left";
				}
				if (lean.leanto_type == 4) {
					const_var.wallNameArray["p_b_c_b_b_r"] = "right";
					const_var.wallNameArray["p_b_c_b_b_l"] = "left";
				}
				const xLean = JSON.parse(JSON.stringify(lean));
				const leanType = LEAN_TYPE_NUM_TO_STR[lean.leanto_type];

				if (xLean.ExtraItemsFeaturesArray) {
					const_var.lNTBuildingData.ExtraItemsFeaturesArray[leanType] = [...xLean.ExtraItemsFeaturesArray];
				}
				if (xLean.ExtraItemsFeaturesQuantityArray) {
					const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray[leanType] = [...xLean.ExtraItemsFeaturesQuantityArray];
				}
				if (xLean.extraAddOnItemsArray) {
					const_var.lNTBuildingData.extraAddOnItemsArray[leanType] = [...xLean.extraAddOnItemsArray];
				}
				if (lean.truss?.id) {
					params.l_t_p[leanType].trussId = lean.truss.id;
				}
			}
		});

		if (editData.ExtraItemsFeaturesArrayForOverhangComputation) {
			const_var.lNTBuildingData.ExtraItemsFeaturesArrayForOverhangComputation = JSON.parse(JSON.stringify(editData.ExtraItemsFeaturesArrayForOverhangComputation ?? []));
		}

		if (const_var.isLTBuilding) {
			if (editData.ExtraItemsFeaturesArray) {
				const_var.lNTBuildingData.ExtraItemsFeaturesArray["centerBuilding"] = JSON.parse(JSON.stringify(editData.ExtraItemsFeaturesArray ?? []));
			}
			if (editData.ExtraItemsFeaturesQuantityArray) {
				const_var.lNTBuildingData.ExtraItemsFeaturesQuantityArray["centerBuilding"] = JSON.parse(JSON.stringify(editData.ExtraItemsFeaturesQuantityArray ?? []));
			}
			if (editData.extraAddOnItemsArray) {
				const_var.lNTBuildingData.extraAddOnItemsArray["centerBuilding"] = JSON.parse(JSON.stringify(editData.extraAddOnItemsArray ?? []));
			}
		}
	}
	applyColorToParams("p_r_c", data?.building?.roof_color);
	applyColorToParams("p_t_c", data?.building?.trim_color);
	applyColorToParams("p_w_c", data?.building?.wall_color);
	if (data.building?.wainscot) {
		if (data.building?.wainscot.hex_value) {
			params.p_w_c_c = data.building?.wainscot.hex_value.replace("#", "0x");
			params.p_w_c_c_name = data.building?.wainscot.name;
			params.p_w_c_c_id = data.building?.wainscot.id;
		}
		if (data.building?.wainscot.image_name) {
			params["wainscotTexture"] = utlis.sidingNameUpdateForWallTexture(data.building?.wainscot.image_name.split(".")[0]);
			params.p_w_c_c = data.building?.wainscot.hex_value.replace("#", "0x");
			params.p_w_c_c_name = data.building?.wainscot.name;
			params.p_w_c_c_id = data.building?.wainscot.id;
		} else {
			params["wainscotTexture"] = "none";
		}
	}
	const building = data?.building;
	if (!building?.wainscot?.hex_value && building?.siding_obj?.name) {
		params["wainscotTexture"] = utlis.sidingNameUpdateForWallTexture(data.building?.wallTexture);
		params.p_w_c_c = data.building?.wall_color?.hex_value.replace("#", "0x");
		params.p_w_c_c_name = data.building?.wall_color?.name;
		params.p_w_c_c_id = data.building?.wall_color?.id;
	}
	if (params.wainscotTexture) {
		const_var.wainscotApiCall = params.wainscotTexture == "none" || params.wainscotTexture == "vertical" ? "" : params.wainscotTexture;
	}
	let deductVal = parseInt(editData.roof_style) - 1;
	state.defaultRoof = const_var.TypeEnumINDEX[editData.roof_style];
	params.p_r_s = parseInt(editData.roof_style);
	params.building_type_name = editData.display_building_type_name != undefined ? editData.display_building_type_name : editData.building_type_name;
	params.other_building_type_name = editData.other_building_type_name;
	params.p_s_n = editData.state;
	params.m_s_n = editData.manufacturer;
	params.selectedState = editData.state;
	params.selectedManufacture = editData.manufacturer_name;
	params.selectedManufactureId = editData.manufacturer;
	const_var.stateChangeflag = params.p_s_n;
	const_var.stateMenuChangeflag = params.m_s_n;
	params.checkeditName = editData.checkeditName != undefined ? editData.checkeditName : false;
	const_var.card_processing_fee = editData.card_processing_fee;
	const_var.state_mfg_zipcode = editData.state_mfg_zipcode != undefined ? editData.state_mfg_zipcode : "";

	params.endStoragePositionZ = editData?.storage_position?.endStoragePositionZ || 0;
	params.leftLeanStoragePosition = editData?.storage_position?.leftLeanStoragePosition || 0;
	params.rightLeanStoragePosition = editData?.storage_position?.rightLeanStoragePosition || 0;
	params.frontLeanStoragePosition = editData?.storage_position?.frontLeanStoragePosition || 0;
	params.backLeanStoragePosition = editData?.storage_position?.backLeanStoragePosition || 0;

	const_var.defaultBuildingImgName = editData.default_building_image_name != undefined && editData.default_building_image_name.split(".")[0];
	if (!const_var.isFromPickThis) {
		const_var.isUpdate4ftLegLogic = editData.isUpdate4ftLegLogic != undefined ? editData.isUpdate4ftLegLogic : false;
	}

	if (!const_var?.state_mfg_zipcode) {
		const_var.is_State_Edit = true;
	}
	if (const_var.state_mfg_zipcode != undefined || const_var.state_mfg_zipcode == "") {
		const_var.is_State_Edit = true;
	}
	if (const_var.editAPIDataByResponse.data != undefined && const_var.editAPIDataByResponse.data.created_at <= "2023-12-13") const_var.isTBSOldQuotesForVerticalRoof = true;

	let newVal = editData.installation_surface.substring(0, 4);
	if (newVal == "grav") {
		editData.installation_surface = "gravel";
	} else if (newVal == "asph") {
		editData.installation_surface = "asphalt";
	} else if (newVal == "grou") {
		editData.installation_surface = "ground";
	} else {
		editData.installation_surface = "concrete";
	}
	params.p_i_s = installationValueArray[upperCaseFirst(editData.installation_surface)];
	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].leanto_style != undefined) {
		params.leanStyle.left = const_var.newLeanArr["left"].leanto_style;
	}

	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].front_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["left"].front_wall == "one_fourth_close" || const_var.newLeanArr["left"].front_wall == "three_fourth_close" || const_var.newLeanArr["left"].front_wall == "half_close")
		) {
			const_var.newLeanArr["left"].front_wall = "Open";
		}
		params.p_b_c_b_l_f = const_var.TypeWallNameForEdit[const_var.newLeanArr["left"].front_wall.toLowerCase()];
	} else {
		params.p_b_c_b_l_f = params.p_b_c_b_l_f;
	}
	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].back_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["left"].back_wall == "one_fourth_close" || const_var.newLeanArr["left"].back_wall == "three_fourth_close" || const_var.newLeanArr["left"].back_wall == "half_close")
		) {
			const_var.newLeanArr["left"].back_wall = "Open";
		}
		params.p_b_c_b_l_b = const_var.TypeWallNameForEdit[const_var.newLeanArr["left"].back_wall.toLowerCase()];
	} else {
		params.p_b_c_b_l_b = params.p_b_c_b_l_b;
	}
	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].side_wall != null) {
		if (const_var.newLeanArr["left"].side_wall == "one_fourth_close" || const_var.newLeanArr["left"].side_wall == "three_fourth_close" || const_var.newLeanArr["left"].side_wall == "half_close") {
			if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
				const_var.newLeanArr["left"].side_wall = "open";
			}
			params.p_b_c_b_l = const_var.TypeWallNameForEdit[const_var.newLeanArr["left"].side_wall.toLowerCase()];
		} else {
			params.p_b_c_b_l = const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].side_wall != null ? upperCaseFirst(const_var.newLeanArr["left"].side_wall) : params.p_b_c_b_l;
		}
	} else {
		params.p_b_c_b_l = const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].side_wall != null ? upperCaseFirst(const_var.newLeanArr["left"].side_wall) : params.p_b_c_b_l;
	}
	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].right_wall != null) {
		if (const_var.newLeanArr["left"].right_wall == "one_fourth_close" || const_var.newLeanArr["left"].right_wall == "three_fourth_close" || const_var.newLeanArr["left"].right_wall == "half_close") {
			params.p_b_c_b_l_r = const_var.TypeWallNameForEdit[const_var.newLeanArr["left"].right_wall.toLowerCase()];
		} else {
			params.p_b_c_b_l_r = const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].right_wall != null ? upperCaseFirst(const_var.newLeanArr["left"].right_wall) : params.p_b_c_b_l_r;
		}
	}

	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].leanto_style != undefined) {
		params.leanStyle.right = const_var.newLeanArr["right"].leanto_style;
	}

	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"] != null && const_var.newLeanArr["right"].front_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["right"].front_wall == "one_fourth_close" || const_var.newLeanArr["right"].front_wall == "three_fourth_close" || const_var.newLeanArr["right"].front_wall == "half_close")
		) {
			const_var.newLeanArr["right"].front_wall = "open";
		}
		params.p_b_c_b_r_f = const_var.TypeWallNameForEdit[const_var.newLeanArr["right"].front_wall];
	} else {
		params.p_b_c_b_r_f = params.p_b_c_b_r_f;
	}
	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"] != null && const_var.newLeanArr["right"].back_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["right"].back_wall == "one_fourth_close" || const_var.newLeanArr["right"].back_wall == "three_fourth_close" || const_var.newLeanArr["right"].back_wall == "half_close")
		) {
			const_var.newLeanArr["right"].back_wall = "open";
		}
		params.p_b_c_b_r_b = const_var.TypeWallNameForEdit[const_var.newLeanArr["right"].back_wall];
	} else {
		params.p_b_c_b_r_b = params.p_b_c_b_r_b;
	}
	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].side_wall != null) {
		if (const_var.newLeanArr["right"].side_wall == "one_fourth_close" || const_var.newLeanArr["right"].side_wall == "three_fourth_close" || const_var.newLeanArr["right"].side_wall == "half_close") {
			if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
				const_var.newLeanArr["right"].side_wall = "open";
			}
			params.p_b_c_b_r = const_var.TypeWallNameForEdit[const_var.newLeanArr["right"].side_wall];
		} else {
			params.p_b_c_b_r =
				const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"] != null && const_var.newLeanArr["right"].side_wall != null
					? upperCaseFirst(const_var.newLeanArr["right"].side_wall)
					: params.p_b_c_b_r;
		}
	} else {
		params.p_b_c_b_r =
			const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"] != null && const_var.newLeanArr["right"].side_wall != null
				? upperCaseFirst(const_var.newLeanArr["right"].side_wall)
				: params.p_b_c_b_r;
	}
	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].right_wall != null) {
		if (const_var.newLeanArr["right"].right_wall == "one_fourth_close" || const_var.newLeanArr["right"].right_wall == "three_fourth_close" || const_var.newLeanArr["right"].right_wall == "half_close") {
			params.p_b_c_b_r_r = const_var.TypeWallNameForEdit[const_var.newLeanArr["right"].right_wall];
		} else {
			params.p_b_c_b_r_r = const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].right_wall != null ? upperCaseFirst(const_var.newLeanArr["right"].right_wall) : params.p_b_c_b_r_r;
		}
	}
	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].leanto_style != undefined) {
		params.leanStyle.front = const_var.newLeanArr["front"].leanto_style;
	}

	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].front_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["front"].front_wall == "one_fourth_close" || const_var.newLeanArr["front"].front_wall == "three_fourth_close" || const_var.newLeanArr["front"].front_wall == "half_close")
		) {
			const_var.newLeanArr["front"].front_wall = "open";
		}

		params.p_b_c_b_f_f = const_var.TypeWallNameForEdit[const_var.newLeanArr["front"].front_wall];
	} else {
		params.p_b_c_b_f_f = params.p_b_c_b_f_f;
	}
	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].back_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["front"].back_wall == "one_fourth_close" || const_var.newLeanArr["front"].back_wall == "three_fourth_close" || const_var.newLeanArr["front"].back_wall == "half_close")
		) {
			const_var.newLeanArr["front"].back_wall = "open";
		}
		params.p_b_c_b_f_b = const_var.TypeWallNameForEdit[const_var.newLeanArr["front"].back_wall];
	} else {
		params.p_b_c_b_f_b = params.p_b_c_b_f_b;
	}

	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].side_wall != null) {
		if (const_var.newLeanArr["front"].side_wall == "one_fourth_close" || const_var.newLeanArr["front"].side_wall == "three_fourth_close" || const_var.newLeanArr["front"].side_wall == "half_close") {
			if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
				const_var.newLeanArr["front"].side_wall = "open";
			}
			params.p_b_c_b_f_l = const_var.TypeWallNameForEdit[const_var.newLeanArr["front"].side_wall];
		} else {
			params.p_b_c_b_f_l = const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].side_wall != null ? upperCaseFirst(const_var.newLeanArr["front"].side_wall) : params.p_b_c_b_f_l;
		}
	} else {
		params.p_b_c_b_f_l = const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].side_wall != null ? upperCaseFirst(const_var.newLeanArr["front"].side_wall) : params.p_b_c_b_f_l;
	}
	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].right_wall != null) {
		if (const_var.newLeanArr["front"].right_wall == "one_fourth_close" || const_var.newLeanArr["front"].right_wall == "three_fourth_close" || const_var.newLeanArr["front"].right_wall == "half_close") {
			if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
				const_var.newLeanArr["front"].right_wall = "open";
			}
			params.p_b_c_b_f_r = const_var.TypeWallNameForEdit[const_var.newLeanArr["front"].right_wall];
		} else {
			params.p_b_c_b_f_r = const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].right_wall != null ? upperCaseFirst(const_var.newLeanArr["front"].right_wall) : params.p_b_c_b_f_r;
		}
	} else {
		params.p_b_c_b_f_r = const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].right_wall != null ? upperCaseFirst(const_var.newLeanArr["front"].right_wall) : params.p_b_c_b_f_r;
	}

	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].right_wall != null) {
		if (const_var.newLeanArr["front"].right_wall == "one_fourth_close" || const_var.newLeanArr["front"].right_wall == "three_fourth_close" || const_var.newLeanArr["front"].right_wall == "half_close") {
			params.p_b_c_b_f_r = const_var.TypeWallNameForEdit[const_var.newLeanArr["front"].right_wall];
		} else {
			params.p_b_c_b_f_r = const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].right_wall != null ? upperCaseFirst(const_var.newLeanArr["front"].right_wall) : params.p_b_c_b_f_r;
		}
	}
	const_var.isCheckGroundCertificate = false;

	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].leanto_style != undefined) {
		params.leanStyle.back = const_var.newLeanArr["back"].leanto_style;
	}

	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].front_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["back"].front_wall == "one_fourth_close" || const_var.newLeanArr["back"].front_wall == "three_fourth_close" || const_var.newLeanArr["back"].front_wall == "half_close")
		) {
			const_var.newLeanArr["back"].front_wall = "open";
		}
		params.p_b_c_b_b_f = const_var.TypeWallNameForEdit[const_var.newLeanArr["back"].front_wall];
	} else {
		params.p_b_c_b_b_f = params.p_b_c_b_b_f;
	}

	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].back_wall != null) {
		if (
			(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
			(const_var.newLeanArr["back"].back_wall == "one_fourth_close" || const_var.newLeanArr["back"].back_wall == "three_fourth_close" || const_var.newLeanArr["back"].back_wall == "half_close")
		) {
			const_var.newLeanArr["back"].back_wall = "open";
		}
		params.p_b_c_b_b_b = const_var.TypeWallNameForEdit[const_var.newLeanArr["back"].back_wall];
	} else {
		params.p_b_c_b_b_b = params.p_b_c_b_b_b;
	}

	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].side_wall != null) {
		if (const_var.newLeanArr["back"].side_wall == "one_fourth_close" || const_var.newLeanArr["back"].side_wall == "three_fourth_close" || const_var.newLeanArr["back"].side_wall == "half_close") {
			if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
				const_var.newLeanArr["back"].side_wall = "open";
			}
			params.p_b_c_b_b_l = const_var.TypeWallNameForEdit[const_var.newLeanArr["back"].side_wall];
		} else {
			params.p_b_c_b_b_l = const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].side_wall != null ? upperCaseFirst(const_var.newLeanArr["back"].side_wall) : params.p_b_c_b_b_l;
		}
	} else {
		params.p_b_c_b_b_l = const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].side_wall != null ? upperCaseFirst(const_var.newLeanArr["back"].side_wall) : params.p_b_c_b_b_l;
	}
	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].right_wall != null) {
		if (const_var.newLeanArr["back"].right_wall == "one_fourth_close" || const_var.newLeanArr["back"].right_wall == "three_fourth_close" || const_var.newLeanArr["back"].right_wall == "half_close") {
			params.p_b_c_b_b_r = const_var.TypeWallNameForEdit[const_var.newLeanArr["back"].right_wall];
		} else {
			params.p_b_c_b_b_r = const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].right_wall != null ? upperCaseFirst(const_var.newLeanArr["back"].right_wall) : params.p_b_c_b_b_r;
		}
	}

	params.b_l_l_t_l = params.p_b_c_b_l;
	params.b_l_l_t_f = params.p_b_c_b_l_f;
	params.b_l_l_t_b = params.p_b_c_b_l_b;
	params.b_l_l_t_r = params.p_b_c_b_l_r;

	params.b_r_l_t_r = params.p_b_c_b_r;
	params.b_r_l_t_f = params.p_b_c_b_r_f;
	params.b_r_l_t_b = params.p_b_c_b_r_b;
	params.b_r_l_t_l = params.p_b_c_b_r_r;

	params.p_b_c_b_f_f = params.p_b_c_b_f_f;
	params.p_b_c_b_f_b = params.p_b_c_b_f_b;
	params.p_b_c_b_f_l = params.p_b_c_b_f_l;

	params.p_b_c_b_b_f = params.p_b_c_b_b_f;
	params.p_b_c_b_b_b = params.p_b_c_b_b_b;
	params.p_b_c_b_b_l = params.p_b_c_b_b_l;

	params.leantoHeight = editData.leanto_height != null ? editData.leanto_height : params.leantoHeight;
	params.p_l_b_l = const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].leanto_type == 1 ? false : true;
	params.p_r_b_l = const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].leanto_type == 2 ? false : true;

	if (
		(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
		(editData.front_wall == "one_fourth_close" || editData.front_wall == "three_fourth_close" || editData.front_wall == "half_close") &&
		!(const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].leanto_type == 3)
	) {
		editData.front_wall = "Open";
	}

	params.p_f_w = const_var.TypeWallNameForEdit[editData.front_wall];
	params.p_f_w_f = params.p_f_w;
	params.b_r_p = editData.roof_pitch;

	if (
		(params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) &&
		(editData.back_wall == "one_fourth_close" || editData.back_wall == "three_fourth_close" || editData.back_wall == "half_close") &&
		!(const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].leanto_type == 4)
	) {
		editData.back_wall = "Open";
	}
	params.p_b_w = const_var.TypeWallNameForEdit[editData.back_wall];
	if (const_var.isFromPickThis) {
		if (state.isFullyEnclosedChecked) params.prev_p_b_w = params.p_b_w;
	}

	if (editData.left_wall == "one_fourth_close" || editData.left_wall == "three_fourth_close" || editData.left_wall == "half_close") {
		if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
			editData.left_wall = "Open";
		}
		params.p_l_w = const_var.TypeWallNameForEdit[editData.left_wall];
	} else {
		params.p_l_w = upperCaseFirst(editData.left_wall);
	}
	if (editData.right_wall == "one_fourth_close" || editData.right_wall == "three_fourth_close" || editData.right_wall == "half_close") {
		if (params.m_s_n == 122 || params.m_s_n == 3 || params.m_s_n == 9 || params.m_s_n == 97) {
			editData.right_wall = "Open";
		}
		params.p_r_w = const_var.TypeWallNameForEdit[editData.right_wall];
	} else {
		params.p_r_w = upperCaseFirst(editData.right_wall);
	}

	if (const_var.isFromCompare == true && params.m_s_n == 97 && (params.p_l_w == "Half_Close" || params.p_l_w == "One_Fourth_Close" || params.p_l_w == "Three_Fourth_Close")) {
		params.p_l_w = "Open";
	}
	if (const_var.isFromCompare == true && params.m_s_n == 97 && (params.p_r_w == "Half_Close" || params.p_r_w == "One_Fourth_Close" || params.p_r_w == "Three_Fourth_Close")) {
		params.p_r_w = "Open";
	}
	params.p_c_p_l = editData.left_wall_cutpanel == true && params.p_l_w != "Close" ? editData.left_wall_cutpanel : false;
	params.p_c_p_r = editData.right_wall_cutpanel == true && params.p_r_w != "Close" ? editData.right_wall_cutpanel : false;
	params.a_c_p_l = editData.left_wall_cutpanel == undefined && params.p_c_p_l == false ? true : params.p_c_p_l;
	params.a_c_p_r = editData.right_wall_cutpanel == undefined && params.p_c_p_r == false ? true : params.p_c_p_r;

	params.p_c_a_w = params.p_b_w == "Close" && params.p_l_w == "Close" && params.p_r_w == "Close" && params.p_f_w == "Close" ? true : false;
	params.p_c_a_l_l_w = params.p_b_c_b_l_f == "Close" && params.p_b_c_b_l_b == "Close" && params.p_b_c_b_l == "Close" ? true : false;
	params.p_c_a_r_l_w = params.p_b_c_b_r_f == "Close" && params.p_b_c_b_r_b == "Close" && params.p_b_c_b_r == "Close" ? true : false;
	params.p_c_a_f_l_w = params.p_b_c_b_f_f == "Close" && params.p_b_c_b_f_b == "Close" && params.p_b_c_b_f_l == "Close" ? true : false;
	params.p_c_a_b_l_w = params.p_b_c_b_b_f == "Close" && params.p_b_c_b_b_b == "Close" && params.p_b_c_b_b_l == "Close" ? true : false;
	const_var.showDefaultInsullation = editData.insulation_type && editData.insulation_type.insulation_id != 0 ? true : false;

	if (editData.legstype != undefined) {
		const_var.reinforcedtype["center"] = editData.legstype;
	}

	params.p_e_l = editData.has_double_leg ? editData.has_double_leg : false;
	const_var.legstype = editData.legstype != undefined ? editData.legstype.toLowerCase() : const_var.legstype.toLowerCase();
	if (editData.leanto.length > 0) {
		let leanLegstype = editData.leanto.find((s) => s.leanto_type == 1);
		const_var.leanLegstype = leanLegstype?.legstype ?? const_var.leanLegstype;
		const_var.leanHasDoublelegName = leanLegstype?.lean_has_double_leg_name ?? const_var.leanHasDoublelegName;
		if (leanLegstype?.legstype !== undefined) {
			const_var.reinforcedtype["left"] = leanLegstype.legstype;
		}
		let leanRLegstype = editData.leanto.find((s) => s.leanto_type == 2);
		const_var.leanRLegstype = leanRLegstype != undefined && leanRLegstype.legstype != undefined ? leanRLegstype.legstype : const_var.leanRLegstype;
		const_var.leanRHasDoublelegName = leanRLegstype != undefined && leanRLegstype.lean_has_double_leg_name != undefined ? leanRLegstype.lean_has_double_leg_name : const_var.leanRHasDoublelegName;
		if (leanRLegstype?.legstype != undefined) {
			const_var.reinforcedtype["right"] = leanRLegstype.legstype;
		}
		let leanFLegstype = editData.leanto.find((s) => s.leanto_type == 3);
		const_var.leanFLegstype = leanFLegstype != undefined && leanFLegstype.legstype != undefined ? leanFLegstype.legstype : const_var.leanFLegstype;
		const_var.leanFHasDoublelegName = leanFLegstype != undefined && leanFLegstype.lean_has_double_leg_name != undefined ? leanFLegstype.lean_has_double_leg_name : const_var.leanFHasDoublelegName;

		if (leanFLegstype?.legstype != undefined) {
			const_var.reinforcedtype["front"] = leanFLegstype.legstype;
		}
		let leanBLegstype = editData.leanto.find((s) => s.leanto_type == 4);
		const_var.leanBLegstype = leanBLegstype != undefined && leanBLegstype.legstype != undefined ? leanBLegstype.legstype : const_var.leanBLegstype;
		const_var.leanBHasDoublelegName = leanBLegstype != undefined && leanBLegstype.lean_has_double_leg_name != undefined ? leanBLegstype.lean_has_double_leg_name : const_var.leanBHasDoublelegName;
		if (leanBLegstype?.legstype != undefined) {
			const_var.reinforcedtype["back"] = leanBLegstype.legstype;
		}
	}
	params.p_t_u = 0;
	params.singleSlope = editData.singleSlope != undefined ? editData.singleSlope : false;

	params.p_i_o = editData.insulation_type ? editData.insulation_type.insulation_id : 0;
	if (allData && allData.paramsData != undefined && allData.paramsData.p_i_o != undefined && allData.paramsData.p_i_o != params.p_i_o) {
		params.p_i_o = allData.paramsData.p_i_o;
	}
	if (const_var.a_p_d_a != undefined && const_var.cbInsulation != undefined && const_var.cbInsulation.find((item) => item.insulation_id == params.p_i_o) == undefined) {
		if (const_var.crmSetting.is_Edit == true && const_var.editAPIDataByResponse.data.request_data.building.insulation_type != undefined) {
			let newName = const_var.cbInsulation.find((item) => item.name.includes(const_var.editAPIDataByResponse.data.request_data.building.insulation_type.name));
			params.p_i_o = newName != undefined ? newName.insulation_id : params.p_i_o;
		}
	}
	params.insulation.center.isCheked = params.p_i_o != 0 ? true : false;
	params.insulation.center.insulationId = params.p_i_o;
	if (params.p_i_o != 0) params.selectedInsulationId = params.p_i_o;
	const_var.showDefaultInsullation = editData.insulation_type && editData.insulation_type.insulation_id != 0 ? true : false;
	const_var.isInsulaltionForOldQuotes = editData.isInsulaltionForOldQuotes != undefined && editData.isInsulaltionForOldQuotes == false ? editData.isInsulaltionForOldQuotes : true;
	if (const_var.isInsulaltionForOldQuotes) {
		params.insulation.frontLean.insulationId = 0;
		params.insulation.leftLean.insulationId = 0;
		params.insulation.rightLean.insulationId = 0;
		params.insulation.backLean.insulationId = 0;
	}
	if (editData.insulation_type != undefined && editData.insulation == "roof_only") {
		params.p_r_o = true;
	} else {
		params.p_r_o = params.p_r_o;
	}

	if (editData.insulation_type != undefined && (editData.insulation == "custom" || editData.insulation == "Custom")) {
		params.p_c_i = true;
	}
	if (editData.leanto != undefined && editData.leanto.length > 0 && (editData.insulation == "custom" || editData.insulation == "Custom")) {
		let isInsulationApplied = editData.leanto.find((obj) => obj.insulation_type != undefined);
		params.p_c_i = isInsulationApplied ? true : false;
	}

	const_var.CheckSnowLoadValue = editData.heavy_snow ? (editData.heavy_snow == 0 ? 35 : 65) : 35;
	if (const_var.CheckSnowLoadValue == 65) {
		params.isSnowLoad = true;
	}
	if (params.p_e_i == "other") {
		params.p_e_i_other = editData.certificate_name;
	}

	if (const_var.newLeanArr["left"] != undefined && const_var.newLeanArr["left"].leanto_type == 1 && const_var.newLeanArr["left"].pricing_data && const_var.newLeanArr["left"].pricing_data != "") {
		params.ShowLeanRecord = true;
		params.continous_left_lean = const_var.newLeanArr["left"].continous_lean == true ? true : false;
		params.add_left_lean = true;
		params.leftLeanStoragePosition = const_var.newLeanArr["left"].utility_position || 0;
		params.lean_p_w = parseInt(const_var.newLeanArr["left"].width);
		params.lean_p_d = parseInt(const_var.newLeanArr["left"].length);
		params.lean_p_h = parseInt(const_var.newLeanArr["left"].height);
		params.lean_p_e_l = const_var.newLeanArr["left"].lean_has_double_leg != undefined ? const_var.newLeanArr["left"].lean_has_double_leg : false;
		const_var.lengthData.leftLean.length = params.lean_p_d;
		if (const_var.newLeanArr["left"].has_utility == undefined) {
			params.add_storage_check = false;
			params.add_storage = 5;
		} else {
			params.add_storage_check = const_var.newLeanArr["left"].has_utility == true ? true : false;
			params.add_storage = const_var.newLeanArr["left"].utility_length ? const_var.newLeanArr["left"].utility_length : 5;
		}
		params.insulation.leftLean.insulationId = const_var.newLeanArr["left"].insulation_type ? const_var.newLeanArr["left"].insulation_type.insulation_id : 0;
		if (params.insulation.leftLean.insulationId != 0) params.selectedInsulationId = params.insulation.leftLean.insulationId;
		params.insulation.leftLean.fullBuilding = const_var.newLeanArr["left"].insulation != undefined && const_var.newLeanArr["left"].insulation == "full" ? true : false;
		params.insulation.leftLean.roofOnly = const_var.newLeanArr["left"].insulation != undefined && const_var.newLeanArr["left"].insulation == "roof_only" ? true : false;
		params.insulation.leftLean.custom = const_var.newLeanArr["left"].insulation != undefined && const_var.newLeanArr["left"].insulation == "custom" ? true : false;
		params.insulation.leftLean.isCheked = params.insulation.leftLean.insulationId != 0 ? true : false;
		params.insulation.leftLean.showInsulationOptions = params.insulation.leftLean.insulationId != 0 ? true : false;

		if (params.lean_p_e_i == "other") {
			params.lean_p_e_i_other = const_var.newLeanArr["left"].certificate_other_name;
		}
		params.leantoAlignmentLeft = const_var.TypeAlingnmentReverse[const_var.newLeanArr["left"].alignment];
		params.leantoAlignmentLeft = params.leantoAlignmentLeft != undefined ? params.leantoAlignmentLeft : 1;
		params.lean_p_pos = const_var.newLeanArr["left"].position != undefined ? const_var.newLeanArr["left"].position : 0;
		if (params.add_storage_check == true && Math.round(params.leftLeanStoragePosition * 10) / 10 == 0) {
			if (const_var.newLeanArr["left"].leanto_style == "gable") {
				params.p_b_c_b_l_b = params.p_l_w != "Close" && Math.round(params.leftLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			} else {
				params.p_b_c_b_l_b = Math.round(params.leftLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			}
		}
		if (const_var.newLeanArr["left"].roof_pitch_name != undefined) {
			params.b_l_t_r_p = const_var.newLeanArr["left"].roof_pitch_name.slice(0, 1);
		}
		if (const_var.newLeanArr["left"].porch != undefined) {
			for (var i = 0; i <= const_var.newLeanArr["left"].porch.wrap_with.length - 1; i++) {
				if (const_var.newLeanArr["left"].porch.wrap_with[i] == "front") {
					params.add_left_front_lean_porch = true;
				}
				if (const_var.newLeanArr["left"].porch.wrap_with[i] == "back") {
					params.add_left_back_lean_porch = true;
				}
				const_var.commonBuildingFlag.wrap = true;
			}
		} else {
			if (const_var.AllBuildingData.data?.manufacture_data?.[0]?.wrap_around == false) {
				params.add_left_front_lean_porch = false;
				params.add_left_back_lean_porch = false;
			}
		}
	} else {
		params.continous_left_lean = false;
		params.add_left_lean = false;
		params.lean_p_e_l = false;
		params.lean_p_w = 12;
		params.lean_p_d = 21;
		params.lean_p_h = 6;
		const_var.lengthData.leftLean.length = params.lean_p_d;
	}
	if (const_var.newLeanArr["front"] != undefined && const_var.newLeanArr["front"].leanto_type == 3) {
		params.ShowLeanRecord = true;
		params.continous_left_lean = const_var.newLeanArr["front"].continous_lean == true ? true : false;
		params.add_front_lean = true;
		params.frontLeanStoragePosition = const_var.newLeanArr["front"].utility_position || 0;
		params.leanF_p_w = parseInt(const_var.newLeanArr["front"].width);
		params.leanF_p_d = parseInt(const_var.newLeanArr["front"].length);
		params.leanF_p_h = parseInt(const_var.newLeanArr["front"].height);
		params.leanF_p_e_l = const_var.newLeanArr["front"].lean_has_double_leg != undefined ? const_var.newLeanArr["front"].lean_has_double_leg : false;
		const_var.lengthData.frontLean.length = params.leanF_p_d;
		if (const_var.newLeanArr["front"].has_utility == undefined) {
			params.add_storage_check_front = false;
			params.add_storage_front = 5;
		} else {
			params.add_storage_check_front = const_var.newLeanArr["front"].has_utility == true ? true : false;
			params.add_storage_front = const_var.newLeanArr["front"].utility_length ? const_var.newLeanArr["front"].utility_length : 5;
		}

		params.insulation.frontLean.insulationId = const_var.newLeanArr["front"].insulation_type ? const_var.newLeanArr["front"].insulation_type.insulation_id : 0;
		if (params.insulation.frontLean.insulationId != 0) params.selectedInsulationId = params.insulation.frontLean.insulationId;
		params.insulation.frontLean.fullBuilding = const_var.newLeanArr["front"].insulation != undefined && const_var.newLeanArr["front"].insulation == "full" ? true : false;
		params.insulation.frontLean.roofOnly = const_var.newLeanArr["front"].insulation != undefined && const_var.newLeanArr["front"].insulation == "roof_only" ? true : false;
		params.insulation.frontLean.custom = const_var.newLeanArr["front"].insulation != undefined && const_var.newLeanArr["front"].insulation == "custom" ? true : false;
		params.insulation.frontLean.isCheked = params.insulation.frontLean.insulationId != 0 ? true : false;
		params.insulation.frontLean.showInsulationOptions = params.insulation.frontLean.insulationId != 0 ? true : false;

		if (state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_f == "Close" && state.params.p_b_c_b_f_b == "Close") {
			state.isFullyEnclosedCheckedForFrontLeanTo = true;
		}
		if (state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_f == "Open" && state.params.p_b_c_b_f_b == "Open") {
			state.isFullyOpenedCheckedForFrontLeanTo = true;
		}
		if (const_var.newLeanArr["front"].alignment == "front") {
			const_var.newLeanArr["front"].alignment = "Left";
		}
		if (const_var.newLeanArr["front"].alignment == "back") {
			const_var.newLeanArr["front"].alignment = "Right";
		}
		params.leantoAlignmentFront = const_var.endLeanAlingnmentTypeReverse[const_var.newLeanArr["front"].alignment];

		params.leantoAlignmentFront = params.leantoAlignmentFront != undefined ? params.leantoAlignmentFront : 1;
		params.leanF_p_pos = const_var.newLeanArr["front"].position != undefined ? const_var.newLeanArr["front"].position : 0;
		if (params.add_storage_check_front == true && Math.round(params.frontLeanStoragePosition * 10) / 10 == 0) {
			if (const_var.newLeanArr["front"].leanto_style == "gable") {
				params.p_b_c_b_f_b = params.p_f_w != "Close" && Math.round(params.frontLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			} else {
				params.p_b_c_b_f_b = Math.round(params.frontLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			}
		}
		if (const_var.newLeanArr["front"].roof_pitch_name != undefined) {
			params.b_l_t_r_pF = const_var.newLeanArr["front"].roof_pitch_name.slice(0, 1);
		}
	} else {
		params.continous_left_lean = false;
		params.add_front_lean = false;
		params.leanF_p_e_l = false;
		params.leanF_p_w = 12;
		params.leanF_p_d = 21;
		params.leanF_p_h = 6;
		const_var.lengthData.frontLean.length = params.leanF_p_d;
	}
	if (const_var.newLeanArr["back"] != undefined && const_var.newLeanArr["back"].leanto_type == 4) {
		params.ShowLeanRecord = true;
		params.continous_left_lean = const_var.newLeanArr["back"].continous_lean == true ? true : false;
		params.add_back_lean = true;
		params.backLeanStoragePosition = const_var.newLeanArr["back"].utility_position || 0;
		params.leanB_p_w = parseInt(const_var.newLeanArr["back"].width);
		params.leanB_p_d = parseInt(const_var.newLeanArr["back"].length);
		params.leanB_p_h = parseInt(const_var.newLeanArr["back"].height);
		params.leanB_p_e_l = const_var.newLeanArr["back"].lean_has_double_leg != undefined ? const_var.newLeanArr["back"].lean_has_double_leg : false;
		const_var.lengthData.backLean.length = params.leanB_p_d;
		if (const_var.newLeanArr["back"].has_utility == undefined) {
			params.add_storage_check_back = false;
			params.add_storage_back = 5;
		} else {
			params.add_storage_check_back = const_var.newLeanArr["back"].has_utility == true ? true : false;
			params.add_storage_back = const_var.newLeanArr["back"].utility_length ? const_var.newLeanArr["back"].utility_length : 5;
		}

		params.insulation.backLean.insulationId = const_var.newLeanArr["back"].insulation_type ? const_var.newLeanArr["back"].insulation_type.insulation_id : 0;
		if (params.insulation.backLean.insulationId != 0) params.selectedInsulationId = params.insulation.backLean.insulationId;
		params.insulation.backLean.fullBuilding = const_var.newLeanArr["back"].insulation != undefined && const_var.newLeanArr["back"].insulation == "full" ? true : false;
		params.insulation.backLean.roofOnly = const_var.newLeanArr["back"].insulation != undefined && const_var.newLeanArr["back"].insulation == "roof_only" ? true : false;
		params.insulation.backLean.custom = const_var.newLeanArr["back"].insulation != undefined && const_var.newLeanArr["back"].insulation == "custom" ? true : false;
		params.insulation.backLean.isCheked = params.insulation.backLean.insulationId != 0 ? true : false;
		params.insulation.backLean.showInsulationOptions = params.insulation.backLean.insulationId != 0 ? true : false;

		if (state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_f == "Close" && state.params.p_b_c_b_b_b == "Close") {
			state.isFullyEnclosedCheckedForBackLeanTo = true;
		}
		if (state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open") {
			state.isFullyOpenedCheckedForBackLeanTo = true;
		}
		if (params.leanB_p_e_i == "other") {
			params.leanB_p_e_i_other = const_var.newLeanArr["back"].certificate_other_name;
		}
		if (const_var.newLeanArr["back"].alignment == "back") {
			const_var.newLeanArr["back"].alignment = "Right";
		}
		if (const_var.newLeanArr["back"].alignment == "front") {
			const_var.newLeanArr["back"].alignment = "Left";
		}

		params.leantoAlignmentBack = const_var.endLeanAlingnmentTypeReverse[const_var.newLeanArr["back"].alignment];
		params.leantoAlignmentBack = params.leantoAlignmentBack != undefined ? params.leantoAlignmentBack : 1;
		params.leanB_p_pos = const_var.newLeanArr["back"].position != undefined ? const_var.newLeanArr["back"].position : 0;
		if (params.add_storage_check_back == true && Math.round(params.backLeanStoragePosition * 10) / 10 == 0) {
			if (const_var.newLeanArr["back"].leanto_style == "gable") {
				params.p_b_c_b_b_b = params.p_b_w != "Close" && Math.round(params.backLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			} else {
				params.p_b_c_b_b_b = Math.round(params.backLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			}
		}
		if (const_var.newLeanArr["back"].roof_pitch_name != undefined) {
			params.b_l_t_r_pB = const_var.newLeanArr["back"].roof_pitch_name.slice(0, 1);
		}
	} else {
		params.continous_left_lean = false;
		params.add_back_lean = false;
		params.leanB_p_e_l = false;
		params.leanB_p_w = 12;
		params.leanB_p_d = 21;
		params.leanB_p_h = 6;
		const_var.lengthData.backLean.length = state.params.leanB_p_d;
	}
	if (const_var.newLeanArr["right"] != undefined && const_var.newLeanArr["right"].leanto_type == 2 && const_var.newLeanArr["right"].pricing_data && const_var.newLeanArr["right"].pricing_data != "") {
		params.ShowLeanRecord = true;
		params.continous_right_lean = const_var.newLeanArr["right"].continous_lean == true ? true : false;
		params.add_right_lean = true;
		params.rightLeanStoragePosition = const_var.newLeanArr["right"].utility_position || 0;
		params.leanR_p_w = parseInt(const_var.newLeanArr["right"].width);
		params.leanR_p_d = parseInt(const_var.newLeanArr["right"].length);
		params.leanR_p_h = parseInt(const_var.newLeanArr["right"].height);
		params.leanR_p_e_l = const_var.newLeanArr["right"].lean_has_double_leg != undefined ? const_var.newLeanArr["right"].lean_has_double_leg : false;
		const_var.lengthData.rightLean.length = params.leanR_p_d;
		if (const_var.newLeanArr["right"].has_utility == undefined) {
			params.add_storage_check_right = false;
			params.add_storage_right = 5;
		} else {
			params.add_storage_check_right = const_var.newLeanArr["right"].has_utility == true ? true : false;
			params.add_storage_right = const_var.newLeanArr["right"].utility_length ? const_var.newLeanArr["right"].utility_length : 5;
		}

		params.insulation.rightLean.insulationId = const_var.newLeanArr["right"].insulation_type ? const_var.newLeanArr["right"].insulation_type.insulation_id : 0;
		if (params.insulation.rightLean.insulationId != 0) params.selectedInsulationId = params.insulation.rightLean.insulationId;
		params.insulation.rightLean.fullBuilding = const_var.newLeanArr["right"].insulation != undefined && const_var.newLeanArr["right"].insulation == "full" ? true : false;
		params.insulation.rightLean.roofOnly = const_var.newLeanArr["right"].insulation != undefined && const_var.newLeanArr["right"].insulation == "roof_only" ? true : false;
		params.insulation.rightLean.custom = const_var.newLeanArr["right"].insulation != undefined && const_var.newLeanArr["right"].insulation == "custom" ? true : false;
		params.insulation.rightLean.isCheked = params.insulation.rightLean.insulationId != 0 ? true : false;
		params.insulation.rightLean.showInsulationOptions = params.insulation.rightLean.insulationId != 0 ? true : false;

		params.leantoAlignmentRight = const_var.TypeAlingnmentReverse[const_var.newLeanArr["right"].alignment];
		params.leantoAlignmentRight = params.leantoAlignmentRight != undefined ? params.leantoAlignmentRight : 1;
		params.leanR_p_pos = const_var.newLeanArr["right"].position != undefined ? const_var.newLeanArr["right"].position : 0;
		if (params.add_storage_check_right == true && Math.round(params.rightLeanStoragePosition * 10) / 10 == 0) {
			if (const_var.newLeanArr["right"].leanto_style == "gable") {
				params.p_b_c_b_r_b = params.p_r_w !== "Close" && Math.round(params.rightLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			} else {
				params.p_b_c_b_r_b = Math.round(params.rightLeanStoragePosition * 10) / 10 == 0 ? "Close" : "Open";
			}
		}
		if (const_var.newLeanArr["right"].roof_pitch_name != undefined) {
			params.b_l_t_r_pR = const_var.newLeanArr["right"].roof_pitch_name.slice(0, 1);
		}
		if (const_var.newLeanArr["right"].porch != undefined) {
			for (var i = 0; i <= const_var.newLeanArr["right"].porch.wrap_with.length - 1; i++) {
				if (const_var.newLeanArr["right"].porch.wrap_with[i] == "front") {
					params.add_right_front_lean_porch = true;
				}
				if (const_var.newLeanArr["right"].porch.wrap_with[i] == "back") {
					params.add_right_back_lean_porch = true;
				}
			}
		} else {
			if (const_var.AllBuildingData.data?.manufacture_data?.[0]?.wrap_around == false) {
				params.add_right_front_lean_porch = false;
				params.add_right_back_lean_porch = false;
			}
		}
	} else {
		params.continous_right_lean = false;
		params.add_right_lean = false;
		params.leanR_p_e_l = false;
		params.leanR_p_w = 12;
		params.leanR_p_d = 21;
		params.leanR_p_h = 6;
		const_var.lengthData.rightLean.length = params.leanR_p_d;
	}
	if (params.add_right_front_lean_porch == true && params.add_right_back_lean_porch == true && params.add_left_front_lean_porch == true && params.add_left_back_lean_porch == true) {
		params.add_full_lean_porch = true;
	}

	if (editData.has_utility != undefined && editData.has_utility == true) {
		if (editData.utility_name == "back") {
			params.p_u_c = editData.has_utility == true ? editData.has_utility : params.p_u_c;
			params.p_u_t = editData.utility_length != null ? editData.utility_length : params.p_u_t;
			params.endStoragePositionZ = editData.utility_position || 0;
		}
		if (editData.utility_name == "left") {
			params.cB_addStorage_check_left = true;
			params.cB_addStorage_left = editData.utility_length;
		}
		if (editData.utility_name == "right") {
			params.cB_addStorage_check_right = true;
			params.cB_addStorage_right = editData.utility_length;
		}
		params.nostorage = false;
	} else {
		params.nostorage = true;
	}

	params.isBreezeway = editData.isBreezeway != undefined ? editData.isBreezeway : false;
	if (editData.has_utility_front != undefined) {
		params.cB_addStorage_check_front = editData.has_utility_front == true ? editData.has_utility_front : params.cB_addStorage_check_front;
		params.cB_addStorage_front = editData.utility_front_length != null ? editData.utility_front_length : params.cB_addStorage_front;
	}

	if (editData.lift_type != undefined) {
		params.lift_type = editData.lift_type;
		params.lifttype_name = editData.lifttype_name;
		params.lifttype_price = editData.lifttype_price;
	} else {
		params.lift_type = editData.lift_type;
	}
	params.display_product_status = data.status;
	params.add_storage_check_1 = params.add_storage_check;
	params.add_storage_check_right_1 = params.add_storage_check_right;

	params.gauge_val = editData.gauge;
	params.p_f_i = editData.insulation == "Fully Insulated" || editData.insulation == "full" ? true : false;
	params.p_r_o = editData.insulation == "Roof Only" || editData.insulation == "roof_only" ? true : false;

	if (
		editData.insulation_type != undefined &&
		(editData.insulation == "roof_only" || editData.insulation == "Roof Only") &&
		editData.height > 10 &&
		editData.manufacturer == 153 &&
		(editData.roof_style == 1 || editData.roof_style == 2) &&
		params.p_r_o == true
	) {
		params.p_r_o = false;
		params.p_i_o = 0;
	}

	if (
		editData.insulation_type != undefined &&
		(editData.insulation == "Fully Insulated" || editData.insulation == "full") &&
		editData.height > 10 &&
		editData.manufacturer == 153 &&
		(editData.roof_style == 1 || editData.roof_style == 2) &&
		params.p_f_i == true
	) {
		params.p_f_i = false;
		params.p_i_o = 0;
	}

	params.p_c_i = editData.insulation == "Custom" || editData.insulation == "custom" ? true : false;

	if (params.m_s_n == 153 && editData.leanto != undefined && editData.leanto.length > 0) {
		let leanToInsulation = editData.leanto.find((item) => item.insulation != undefined);
		if (leanToInsulation != undefined) {
			params.p_f_i = leanToInsulation.insulation == "Fully Insulated" || leanToInsulation.insulation == "full" ? true : false;
			params.p_r_o = leanToInsulation.insulation == "Roof Only" || leanToInsulation.insulation == "roof_only" ? true : false;
			params.p_c_i = leanToInsulation.insulation == "Custom" || leanToInsulation.insulation == "custom" ? true : false;
		}
	}
	  params.p_v_w = !!editData.vertical_walls;

	let orientationObject = [];
	if (editData.siding_obj?.panel_orientation != undefined && editData.siding_obj?.panel_orientation?.length > 0) {
		orientationObject = [];
		editData.siding_obj.panel_orientation.map((obj, idx) => {
			orientationObject.push({
				value: obj,
				label: obj
			});
		});
		const_var.sidingOrientationOptions = editData.siding_name != "metal" ? orientationObject : getSidingOrientationOptions();
	} else {
		if (editData.siding_name && editData.siding_name != "metal") {
			const_var.sidingOrientationOptions = [{ value: "vertical", label: "Vertical" }];
		} else {
			const_var.sidingOrientationOptions = getSidingOrientationOptions();
		}
	}

	let selectedOrientation = "";
	if (editData?.wallOrientation == undefined) {
		selectedOrientation =
			editData?.siding_name != "metal" ? (editData.siding_name?.includes("horizontal") ? "horizontal" : editData.siding_name?.includes("vertical") ? "vertical" : "") : params.p_v_w ? "vertical" : "horizontal";
	}

	if (params.p_v_w) {
		if (const_var.isFromPickThis) {
			if (editData?.siding_name != "metal" && previousSelSidingOption == editData?.siding_name) {
				if (previousSelSidingOption != previousWallTexture) {
					let sidingColor = allData.building_data.color.filter((obj) => obj?.sheet_name == previousSelSidingOption);
					if (sidingColor?.length > 0) {
						let isWallTextureExsist = sidingColor?.filter((obj) => obj?.image_name && obj.image_name?.toLowerCase()?.includes(previousWallTexture));
						if (isWallTextureExsist?.length > 0) {
							params.wallTexture = utlis.sidingNameUpdateForWallTexture(isWallTextureExsist[0].image_name?.split(".")[0]);
						} else {
							params.wallTexture = utlis.sidingNameUpdateForWallTexture(sidingColor[0].image_name?.split(".")[0]);
						}
					}
				} else {
					params.wallTexture = utlis.sidingNameUpdateForWallTexture(editData.siding_name);
				}
			} else {
				params.wallTexture = "vertical";
			}
		} else if (const_var.crmSetting.is_Edit) {
			params.wallTexture = editData.wallTexture ? utlis.sidingNameUpdateForWallTexture(editData.wallTexture) : "vertical";
			params.wallOrientation = editData.wallOrientation != undefined ? editData.wallOrientation : selectedOrientation;
		} else {
			params.wallTexture = editData.siding_name == "metal" ? "vertical" : utlis.sidingNameUpdateForWallTexture(editData.siding_name);
			params.wallOrientation = editData.wallOrientation != undefined ? editData.wallOrientation : selectedOrientation;
		}
		if (editData.siding_name != undefined) {
			const_var.selSidingOption = editData.siding_name != undefined ? editData.siding_name : "metal";
		} else {
			const_var.selSidingOption = editData.siding_name != undefined ? editData.siding_name : "metal";
		}
	} else {
		if (editData.siding_name != undefined) {
			const_var.selSidingOption = editData.siding_name;
			params.wallTexture =
				editData.wallTexture != undefined ? utlis.sidingNameUpdateForWallTexture(editData.wallTexture) : editData.siding_name == "metal" ? "none" : utlis.sidingNameUpdateForWallTexture(editData.siding_name);

			params.wallOrientation = editData.wallOrientation != undefined ? editData.wallOrientation : selectedOrientation;
		} else {
			params.wallTexture = editData.wallTexture != undefined ? utlis.sidingNameUpdateForWallTexture(editData.wallTexture) : "none";
			params.wallOrientation = editData.wallOrientation != undefined ? editData.wallOrientation : selectedOrientation;
		}
	}
	if (editData.siding_name != undefined) {
		const_var.selSidingOption = editData.siding_name;

		params.wallTexture = const_var.selSidingOption == "metal" ? "none" : params.wallTexture;
	}

	if (editData.siding_obj != undefined) {
		const_var.selSidingObj = editData.siding_obj;
	}
	if (editData.selSidingObj != undefined) {
		const_var.selSidingObj = editData.selSidingObj;
	}

	params.cupola = editData.cupola_obj != undefined || editData.cupolas != undefined ? true : false;
	params.cupolasize = editData.cupola_obj != undefined ? editData.cupola_obj.id : "";
	params.cupolaQty = editData.cupola_qty != undefined ? editData.cupola_qty : params.cupolaQty;
	params.cupolaObj = editData.cupola_obj != undefined ? editData.cupola_obj : {};
	const_var.cupolaPosition = editData.cupola_pos != undefined ? editData.cupola_pos : const_var.cupolaPosition;
	const_var.cupolaEntries = editData.cupolaEntries ? editData.cupolaEntries : [];
	const_var.cupolas = editData.cupolas ? editData.cupolas : [];

	params.newtrussType = editData.edit_truss_name != undefined ? editData.edit_truss_name : "";
	params.truss_type_name = editData.truss_type_name != undefined ? editData.truss_type_name : "";
	if (const_var.controls != undefined && const_var.controls != "") {
		let fLength = params.p_d;
		let fWidth = params.p_w;
		params.add_front_lean && (fLength += params.leanF_p_w);
		params.add_back_lean && (fLength += params.leanB_p_w);
		params.add_left_lean && (fWidth += params.lean_p_w);
		params.add_right_lean && (fWidth += params.leanR_p_w);
		let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
		const_var.controls.maxDistance = diag >= 100 ? 500 : diag * 6;
	}
	let fLength = params.p_d;
	let fWidth = params.p_w;
	params.add_front_lean && (fLength += params.leanF_p_w);
	params.add_back_lean && (fLength += params.leanB_p_w);
	params.add_left_lean && (fWidth += params.lean_p_w);
	params.add_right_lean && (fWidth += params.leanR_p_w);
	let diag = new THREE.Vector3(fLength, fWidth, params.p_h).length();
	let zMul = 2;
	if (window.innerWidth < 1000) {
		zMul = 3;
	}

	params.tax_exempt = editData.tax_exempt == 1 ? editData.tax_exempt : params.tax_exempt;
	if (editData.payment_mode != undefined && editData.payment_mode.type != undefined) {
		if (const_var.crmSetting.main_domain_url != undefined && const_var.crmSetting.main_domain_url == "eaglebuildings.com") {
			if (editData.payment_mode.type == "cash") {
				params.paymentmode = "cod";
				const_var.paymentOptionObj[params.paymentmode] = { type: "cash_on_delivery", finance_company: "", application_id: "", plan_no: "" };
			} else {
				params.paymentmode = const_var.getPaymentValue[editData.payment_mode.type];
				const_var.paymentOptionObj[params.paymentmode] = editData.payment_mode;
			}
		} else {
			params.paymentmode = const_var.getPaymentValue[editData.payment_mode.type];
			const_var.paymentOptionObj[params.paymentmode] = editData.payment_mode;
		}
	}

	if (editData.garage_door_color != undefined && Object.keys(editData.garage_door_color).length > 0) {
		params.g_d_c = editData.garage_door_color.hex_value.replace("#", "0x");
		params.g_d_c_name = editData.garage_door_color.name;
		params.g_d_c_id = editData.garage_door_color;
	}
	if (editData.surcharge_amount == undefined) {
		editData.surcharge_amount = 0;
	}
	if (editData.surcharge_amount) {
		if (editData.surcharge_taxable == undefined) {
			const_var.UpdatedPriceData.surcharge_taxable = 0;
		}
	}
	const_var.estimator_QuestionAnswer = data.questions != undefined ? data.questions : const_var.estimator_QuestionAnswer;
	if (editData.order_extra_items != undefined && editData.order_extra_items.surchargeFees == undefined) {
		editData.order_extra_items.surchargeFees = 0;
	}
	if (editData.order_extra_items != undefined && editData.order_extra_items.concrete_work == undefined) {
		editData.order_extra_items.concrete_work = 0;
	}
	if (editData.order_extra_items != undefined && editData.order_extra_items.ground_work == undefined) {
		editData.order_extra_items.ground_work = 0;
	}

	if (editData.job_site_level || editData.surface_level) {
		if (editData.surface_level) {
			editData.job_site_level = editData.surface_level;
		}
		params.job_site_level = editData.job_site_level;
		if (editData.order_extra_items != undefined) {
			editData.order_extra_items["job_site_level"] = editData.job_site_level;
		}
	}
	if (editData.electricity) {
		params.power_avail = editData.electricity;
		if (editData.order_extra_items != undefined) {
			editData.order_extra_items["electricity"] = editData.electricity;
		}
	}
	if (editData.surface_level != null || editData.surface_level != undefined) {
		params.job_site_level = editData.surface_level;
		editData.order_extra_items["surface_level"] = editData.surface_level;
	} else {
		params.job_site_level = "no";
	}
	if (editData.electricity != null || editData.electricity != undefined) {
		params.power_avail = editData.electricity;
		editData.order_extra_items["electricity"] = editData.electricity;
	} else {
		params.power_avail = "no";
	}
	if (const_var.crmSetting.is_Edit == true && editData.order_extra_items["additional_note"] == null) {
		editData.order_extra_items["additional_note"] = "";
		const_var.order_extra_items["additional_note"] = "";
	}
	const_var.order_extra_items = editData.order_extra_items != undefined ? editData.order_extra_items : const_var.order_extra_items;
	if (editData.permit != undefined) {
		if (editData.order_extra_items != undefined) {
			editData.order_extra_items["permit"] = editData.permit;
		}
	}

	const_var.order_extra_items.grvy_value = const_var.order_extra_items.grvy_value == undefined ? 0 : const_var.order_extra_items.grvy_value;

	if (editData.additional_note) {
		params.additional_note = editData.additional_note;
	}

	const_var.dealer_discount_label = editData.dealer_discount_label != undefined ? editData.dealer_discount_label : "";
	const_var.manufacturer_discount_changed = editData.manufacturer_discount_label != undefined && editData.discount_rate_updated ? true : false;
	const_var.manufacturer_discount_label = editData.manufacturer_discount_label != undefined ? editData.manufacturer_discount_label : "";
	const_var.edited_manufacturer_discount_label = editData.manufacturer_discount_label != undefined ? editData.manufacturer_discount_label : "";
	const_var.inputs = editData.inputs != undefined ? editData.inputs : const_var.inputs;
	const_var.Componentinputs = editData.Componentinputs != undefined ? editData.Componentinputs : const_var.Componentinputs;
	const_var.additionalChargeArr = editData.AdditionalCharges != undefined ? editData.AdditionalCharges : const_var.additionalChargeArr;
	const_var.ExtraItemsFeaturesArray = editData.ExtraItemsFeaturesArray != undefined ? editData.ExtraItemsFeaturesArray : const_var.ExtraItemsFeaturesArray;
	const_var.extraAddOnItemsArray = editData.extraAddOnItemsArray != undefined ? editData.extraAddOnItemsArray : const_var.extraAddOnItemsArray;

	if (const_var.inputs?.length > 0) {
		for (let i = const_var.inputs.length - 1; i >= 0; i--) {
			const obj = const_var.inputs[i];

			if (!obj?.additional_name || !obj?.additional_quantity) {
				const_var.inputs.splice(i, 1);
			}
		}
	}
	if (const_var.Componentinputs?.length > 0) {
		for (let i = const_var.Componentinputs.length - 1; i >= 0; i--) {
			const obj = const_var.Componentinputs[i];

			if (!obj?.additional_name || !obj?.additional_quantity) {
				const_var.Componentinputs.splice(i, 1);
			}
		}
	}

	if (editData.leanto?.length > 0) {
		for (let i = 0; i < editData.leanto.length; i++) {
			if (editData.leanto[i].leanto_type == 1) {
				if (editData.leanto[i].leanto_style == "gable") {
				} else {
					const_var.extraAddOnItemsArrayList["left"] = editData.leanto[i].extraAddOnItemsArray ? editData.leanto[i].extraAddOnItemsArray : [];
				}
			}
			if (editData.leanto[i].leanto_type == 2) {
				if (editData.leanto[i].leanto_style == "gable") {
				} else {
					const_var.extraAddOnItemsArrayList["right"] = editData.leanto[i].extraAddOnItemsArray ? editData.leanto[i].extraAddOnItemsArray : [];
				}
			}
			if (editData.leanto[i].leanto_type == 3) {
				if (editData.leanto[i].leanto_style == "gable") {
				} else {
					const_var.extraAddOnItemsArrayList["front"] = editData.leanto[i].extraAddOnItemsArray ? editData.leanto[i].extraAddOnItemsArray : [];
				}
			}
			if (editData.leanto[i].leanto_type == 4) {
				if (editData.leanto[i].leanto_style == "gable") {
				} else {
					const_var.extraAddOnItemsArrayList["back"] = editData.leanto[i].extraAddOnItemsArray ? editData.leanto[i].extraAddOnItemsArray : [];
				}
			}
		}
	}

	if (editData.ExtraItemsFeaturesArray != undefined && editData.ExtraItemsFeaturesArray.length > 0) {
		let overhangOpt = editData.ExtraItemsFeaturesArray.filter(
			(obj) => obj != null && ((obj.name != undefined && obj.name == "overhang") || (obj.sheet_name != undefined && obj.sheet_name.toLowerCase().includes("overhang")))
		);

		let endOverhang = [];
		let sideOverhang = [];
		let bothOverhang = [];
		let EndSize = 0.5;
		let SideSize = 0.5;
		let BothSize = 0.5;

		endOverhang =
			overhangOpt.length > 0 && (overhangOpt[0].sheet_type == undefined || overhangOpt[0].sheet_type != "both")
				? overhangOpt.filter((obj) => (obj.label && obj.label != undefined ? obj.label.toLowerCase().includes("end") : obj.sheet_name.toLowerCase().includes("end")))
				: [];

		sideOverhang =
			overhangOpt.length > 0 && (overhangOpt[0].sheet_type == undefined || overhangOpt[0].sheet_type != "both")
				? overhangOpt.filter((obj) => (obj.label && obj.label != undefined ? obj.label.toLowerCase().includes("side") : obj.sheet_name.toLowerCase().includes("side")))
				: [];

		bothOverhang =
			overhangOpt.length > 0 && overhangOpt[0].sheet_type != undefined && overhangOpt[0].sheet_type == "both"
				? overhangOpt.filter((obj) => obj.sheet_type && obj.sheet_type != undefined && obj.sheet_type == "both")
				: [];

		if (
			const_var.a_p_d_a.overhang != undefined &&
			((const_var.a_p_d_a.overhang.end != undefined && const_var.a_p_d_a.overhang.end.length > 0) ||
				(const_var.a_p_d_a.overhang.side != undefined && const_var.a_p_d_a.overhang.side.length > 0) ||
				(const_var.a_p_d_a.overhang.both != undefined && const_var.a_p_d_a.overhang.both != "" && const_var.a_p_d_a.overhang.both != null))
		) {
			EndSize = endOverhang.length > 0 ? (endOverhang[0].sheet_name != undefined ? calcOverhangSize(endOverhang[0].sheet_name) : calcOverhangSize(endOverhang[0].label)) : 0.5;
			SideSize = sideOverhang.length > 0 ? (sideOverhang[0].sheet_name != undefined ? calcOverhangSize(sideOverhang[0].sheet_name) : calcOverhangSize(sideOverhang[0].label)) : 0.5;
			BothSize = bothOverhang.length > 0 ? 1 : 0.5;
		} else {
			EndSize = endOverhang.length > 0 ? 1 : 0.5;
			SideSize = sideOverhang.length > 0 ? 1 : 0.5;
			BothSize = bothOverhang.length > 0 ? 1 : 0.5;
		}

		const_var.isOverhang = {
			end: {
				isChecked: endOverhang.length > 0 || bothOverhang.length > 0 ? true : false,
				selected: bothOverhang.length > 0 ? "1' Overhang on Ends" : endOverhang.length > 0 ? (endOverhang[0].sheet_name ? endOverhang[0].sheet_name : endOverhang[0].label) : "",
				size: bothOverhang.length > 0 ? 1 : EndSize
			},
			side: {
				isChecked: sideOverhang.length > 0 || bothOverhang.length > 0 ? true : false,
				selected: bothOverhang.length > 0 ? "1' Overhang on Sides" : sideOverhang.length > 0 ? (sideOverhang[0].sheet_name ? sideOverhang[0].sheet_name : sideOverhang[0].label) : "",
				size: bothOverhang.length > 0 ? 1 : SideSize
			},
			both: {
				isChecked: bothOverhang.length > 0 ? true : false,
				selected: bothOverhang.length > 0 ? (bothOverhang[0].sheet_name ? bothOverhang[0].sheet_name : bothOverhang[0].label) : "",
				size: BothSize
			}
		};

		if (const_var.isOverhang.both.isChecked == true) {
			params.o_v_h_n_g = true;
			params.o_v_h_n_g_e = true;
		} else {
			let isSideChecked = const_var.ExtraItemsFeaturesArray.filter((obj) => obj && (obj.sheet_name ? obj.sheet_name.toLowerCase().includes("side") : obj?.label?.toLowerCase().includes("side")));
			let isEndChecked = const_var.ExtraItemsFeaturesArray.filter((obj) => obj && (obj.sheet_name ? obj.sheet_name.toLowerCase().includes("end") : obj?.label?.toLowerCase().includes("end")));

			params.o_v_h_n_g = isSideChecked.length > 0 ? (isSideChecked[0].is_checked == true ? true : false) : false;
			params.o_v_h_n_g_e = isEndChecked.length > 0 ? (isEndChecked[0].is_checked == true ? true : false) : false;

			const_var.isOverhang.end.isChecked = params.o_v_h_n_g_e;
			const_var.isOverhang.side.isChecked = params.o_v_h_n_g;
		}
	}

	const_var.ExtraItemsFeaturesQuantityArray = editData.ExtraItemsFeaturesQuantityArray ?? const_var.ExtraItemsFeaturesQuantityArray;
	if (editData.parentTax != undefined && !const_var.checkPickThisBuilding) {
		if (typeof editData.parentTax.percentage == "string") {
			editData.parentTax.percentage = editData.parentTax.percentage.replace(/[^\d.-]/g, "");
		}
		if (editData.parentTax.percentage.length > 0) {
			editData.parentTax.percentage = editData.parentTax.percentage[0].replace(/[^\d.-]/g, "");
		}
		if (editData.parentTax.type == "amt") {
			if (typeof editData.parentTax.amount == "string") {
				editData.parentTax.amount = editData.parentTax.amount.replace(/[^\d.-]/g, "");
			}
			if (editData.parentTax.amount.length > 0) {
				editData.parentTax.amount = editData.parentTax.amount[0].replace(/[^\d.-]/g, "");
			}
		}
	}

	const_var.tax = editData.parentTax != undefined ? editData.parentTax : const_var.tax;
	const_var.MoreTaxinputs = editData.MoreTaxinputs != undefined ? editData.MoreTaxinputs : const_var.MoreTaxinputs;
	if (const_var.MoreTaxinputs != undefined && !const_var.checkPickThisBuilding) {
		const_var.MoreTaxinputs.map((val, index) => {
			if (val.name == null && val.percentage == null) {
				const_var.MoreTaxinputs.splice(index, 1);
			}
			if (typeof val.percentage == "string") {
				const_var.MoreTaxinputs[index].percentage = val.percentage.replace(/[^\d.-]/g, "");
			}
			if (val.percentage != null && val.percentage.length > 0) {
				const_var.MoreTaxinputs[index].percentage = val.percentage[0].replace(/[^\d.-]/g, "");
			}
			if (typeof val.more_tax_amount == "string") {
				const_var.MoreTaxinputs[index].more_tax_amount = val.more_tax_amount.replace(/[^\d.-]/g, "");
			}
			if (val.more_tax_amount != undefined && val.more_tax_amount.length > 0) {
				const_var.MoreTaxinputs[index].more_tax_amount = val.more_tax_amount[0].replace(/[^\d.-]/g, "");
			}
			if (val.type == "amt") {
				if (typeof val.amount == "string") {
					const_var.MoreTaxinputs[index].amount = val.amount.replace(/[^\d.-]/g, "");
				}
				if (val.amount != undefined && val.amount.length > 0) {
					const_var.MoreTaxinputs[index].amount = val.amount[0].replace(/[^\d.-]/g, "");
				}
			}
		});
	}

	if (sourceData != undefined && sourceData != "") {
		if (Object.keys(sourceData).length > 0) {
			sourceData.map((val, index) => {
				if (editData.parentTax != undefined) {
					if (index == 0) {
						const_var.tax = val;
						const_var.tax.tax_value = val.percentage;
					}
					if (index > 0) {
						const_var.MoreTaxinputs[index - 1] = val;
						const_var.MoreTaxinputs[index - 1].more_tax_amount = val.more_tax_amount;
					}
				} else {
					const_var.MoreTaxinputs[index] = val;
					const_var.MoreTaxinputs[index].more_tax_amount = val.more_tax_amount;
				}
			});
		}
	}
	const_var.check_siding_material_price = editData.siding_name != undefined && editData.siding_name != "metal" ? true : false;
	if (editData.connection_fee_side != undefined && editData.connection_fee_side != 0) {
		const_var.UpdatedPriceData.connection_fee_side = editData.connection_fee_side;
	}
	if (editData.connection_fee_end != undefined && editData.connection_fee_end != 0) {
		const_var.UpdatedPriceData.connection_fee_end = editData.connection_fee_end;
	}

	params.oncenter_val_with_action = editData.custom_distance_on_center != undefined ? editData.custom_distance_on_center : "";
	params.oncenter_val = editData.custom_distance_on_center != undefined ? editData.custom_distance_on_center : 0;

	const_var.UpdatedPriceData.elements = [];
	const_var.LeadCustomerData["first_name"] = personlInfo.first_name == "" ? undefined : personlInfo.first_name;
	const_var.LeadCustomerData["last_name"] = personlInfo.last_name;
	const_var.LeadCustomerData["email"] = personlInfo.email;
	const_var.LeadCustomerData["phone_no"] = personlInfo.phone_no != undefined ? personlInfo.phone_no : "";
	const_var.LeadCustomerData["mobile_no"] = personlInfo.mobile_no != undefined ? personlInfo.mobile_no : "";
	const_var.leadSourceStateData = statesRec != undefined ? statesRec : "";
	if (personlInfo.address != undefined) {
		let priceData = personlInfo.address.filter((address) => address.is_billing == 1);
		const_var.LeadCustomerData["address"] = personlInfo.address;
		personlInfo.address.map((val, index) => {
			const_var.LeadCustomerData["address"][index].notRemove = true;
			const_var.addressBook.push({ new_address_line_1: val.address_line_1, new_address_line_2: val.address_line_2, new_zipcode: val.zipcode, new_state: val.state, new_city: val.city, new_county: val.county });
		});
		let installationAddData = personlInfo.address.filter((address) => address.is_installation == 1);
		if (installationAddData != undefined && installationAddData.length > 0) {
			const_var.LeadCustomerData["shipping_address_line_1"] = installationAddData[0].address_line_1;
			const_var.LeadCustomerData["shipping_address_line_2"] = installationAddData[0].address_line_2;
			const_var.LeadCustomerData["shipping_city"] = installationAddData[0].city;
			const_var.LeadCustomerData["shipping_country"] = installationAddData[0].county;
			const_var.LeadCustomerData["shipping_state"] = installationAddData[0].state;
			const_var.LeadCustomerData["shipping_zipcode"] = installationAddData[0].zipcode;
		}
	}

	const_var.crmSetting.is_show_background =
		editData.is_showBackgroundImage != undefined && editData.is_showBackgroundImage != ""
			? editData.is_showBackgroundImage
			: const_var.crmSetting.is_show_background != undefined
				? const_var.crmSetting.is_show_background
				: false;
	if (
		data.billing_address_line_1 != undefined &&
		data.billing_address_line_2 != undefined &&
		data.billing_city != undefined &&
		data.billing_country != undefined &&
		data.billing_state != undefined &&
		data.billing_zipcode != undefined
	) {
		const_var.LeadCustomerData["billing_address_line_1"] = const_var.LeadCustomerData["address_line_1"] = data.billing_address_line_1;
		const_var.LeadCustomerData["billing_address_line_2"] = const_var.LeadCustomerData["address_line_2"] = data.billing_address_line_2;
		const_var.LeadCustomerData["billing_city"] = const_var.LeadCustomerData["city"] = data.billing_city;
		const_var.LeadCustomerData["billing_country"] = const_var.LeadCustomerData["country"] = data.billing_country;
		const_var.LeadCustomerData["billing_state"] = const_var.LeadCustomerData["state"] = data.billing_state;
		const_var.LeadCustomerData["billing_zipcode"] = const_var.LeadCustomerData["zipcode"] = data.billing_zipcode;
	}
	if (
		data.shipping_address_line_1 != undefined &&
		data.shipping_address_line_2 != undefined &&
		data.shipping_city != undefined &&
		data.shipping_state != undefined &&
		data.shipping_country != undefined &&
		data.shipping_zipcode != undefined
	) {
		const_var.LeadCustomerData["shipping_address_line_1"] = data.shipping_address_line_1;
		const_var.LeadCustomerData["shipping_address_line_2"] = data.shipping_address_line_2;
		const_var.LeadCustomerData["shipping_city"] = data.shipping_city;
		const_var.LeadCustomerData["shipping_state"] = data.shipping_state;
		const_var.LeadCustomerData["shipping_country"] = data.shipping_country;
		const_var.LeadCustomerData["shipping_zipcode"] = data.shipping_zipcode;
	}

	const_var.LeadCustomerData["ShowEdit"] = data.ShowEdit != undefined ? data.ShowEdit : data.shipping_address_line_1 != undefined || data.shipping_zipcode != undefined ? true : false;

	if (data.ShowEdit == undefined && data.shipping_address_line_1 == undefined && data.shipping_zipcode == undefined && personlInfo.address != undefined && personlInfo.address.length > 0) {
		let defaultAdd = personlInfo.address.filter((obj) => obj.is_default == 1);
		const_var.LeadCustomerData["ShowEdit"] = defaultAdd.length > 0 ? true : const_var.LeadCustomerData["ShowEdit"];
	}

	const_var.LeadCustomerData["is_Action"] = data.is_Action;
	const_var.LeadCustomerData["lead_source"] = data.lead_source;
	if (data.sensei_sales_id != undefined) {
		const_var.LeadCustomerData["sensei_sales_id"] = data.sensei_sales_id;
	}

	if (building_images != undefined && building_images.length > 0 && const_var.crmSetting.form_action != "duplicate") {
		building_images.map((val, index) => {
			if (val.image_name != "2D Layout" && val.image_name != "2D Layout1" && val.image_name != "ig_image" && val.image_name != "ig-image") {
				const_var.i_g_A_y.push({ image: val.image, image_name: val.image_name, description: val.description });
			} else {
				if (val.image_name == "2D Layout1" && val.is_checked == true) {
					const_var.i_g_A_y.push({ image: val.image, image_name: val.image_name, is_checked: val.is_checked });
				}
			}
		});
		const_var.checkCaptuareImage = true;
		building_images.map((val, index) => {
			converImageIntoBase64(val.image, function (dataUrl) {
				if (val.image_name != "2D Layout" && val.image_name != "2D Layout1" && val.image_name != "ig_image" && val.image_name != "ig-image") {
					const_var.i_g_A_y[index] = { image: dataUrl, image_name: val.image_name, description: val.description };
				} else {
					if (val.image_name == "2D Layout1" && val.is_checked == false) {
						const_var.i_g_A_y.splice(index, 1);
					}
					if (val.image_name == "2D Layout1" && val.is_checked == true) {
						const_var.i_g_A_y[index] = { image: dataUrl, image_name: val.image_name, is_checked: val.is_checked };
					}
				}
			});
		});
		let checkImages = building_images.filter((data) => data.is_checked != undefined && data.is_checked == true);
		if (checkImages.length > 0) {
			const_var.ShowTwodLayoutDefault = true;
		}
	}

	const_var.crmSetting.sub_module = data.sub_module ? data.sub_module : const_var.crmSetting.sub_module;
	if (const_var.isFromCompare != true) {
		if (data.sub_module_id == null || data.sub_module_id == undefined) {
			const_var.crmSetting.sub_module_id = personlInfo.u_id;
		} else {
			const_var.crmSetting.sub_module_id = data.sub_module_id;
		}
	}
	const_var.editstateColorAcordingAPI[params.p_s_n] = {
		wall_color: editData.wall_color != undefined && Object.keys(editData.wall_color).length > 0 ? editData.wall_color : undefined,
		roof_color: editData.roof_color,
		trim_color: editData.trim_color,
		wainscot: editData.wainscot,
		garageDoorColor: editData.garageDoorColor
	};
	if (editData.wall_color != undefined && Object.keys(editData.wall_color).length > 0) {
		const_var.showWallColorJSX = false;
	}

	if (editData.roof_pitch != undefined) {
		params.b_r_p = editData.roof_pitch.replace("/", "");

		let chkSingleSlopeBuilding = "";
		if (const_var.editAPIDataByResponse.data.building_data != undefined) {
			chkSingleSlopeBuilding = const_var.editAPIDataByResponse.data.building_data.building.filter((data) => data.fixed_new_leg_width != undefined && data.fixed_new_leg_width.length > 0);
		}

		if (params.singleSlope == true && chkSingleSlopeBuilding != "" && chkSingleSlopeBuilding.length > 0 && const_var.editAPIDataByResponse.data.created_at >= "2024-01-24") {
			let newRoofPitch = Number(editData.roof_pitch.split("/")[0]) > 2 ? Number(editData.roof_pitch.split("/")[0]) - 1 : Number(editData.roof_pitch.split("/")[0]);
			params.p_r_p = newRoofPitch;
		} else {
			params.p_r_p = editData.roof_pitch.split("/")[0];
		}
	}
	if (editData.has_double_leg === true) {
		const_var.commonBuildingFlag.center.buildingHeight = true;
	}
	let leanArr = const_var.newLeanArr;

	if (const_var.newLeanArr["left"]?.lean_has_double_leg != undefined && const_var.newLeanArr["left"]?.lean_has_double_leg === true) {
		const_var.commonBuildingFlag.leftLean.leftLeanHeight = true;
	}
	if (const_var.newLeanArr["right"]?.lean_has_double_leg != undefined && const_var.newLeanArr["right"]?.lean_has_double_leg === true) {
		const_var.commonBuildingFlag.rightLean.rightLeanHeight = true;
	}
	if (const_var.newLeanArr["front"]?.lean_has_double_leg != undefined && const_var.newLeanArr["front"]?.lean_has_double_leg === true) {
		const_var.commonBuildingFlag.frontLean.frontLeanHeight = true;
	}
	if (const_var.newLeanArr["back"]?.lean_has_double_leg != undefined && const_var.newLeanArr["back"]?.lean_has_double_leg === true) {
		const_var.commonBuildingFlag.backLean.backLeanHeight = true;
	}

	if (const_var.isLTBuilding && params.add_left_lean == true && params.leanStyle.left === "gable") {
		const_var.navEventKey.leanto = "rightLean";
	}
	const selectedDefaultBuilding = allData?.building_data?.default_building?.find((obj) => obj.id == 1);
};
